import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuildingImagesDetialsComponent } from '../../building-Image/building-images-detials/building-images-detials.component';
import { BuildingDataService } from '../building-data.service';

@Component({
  selector: 'app-building-image-details',
  templateUrl: './building-image-details.component.html',
  styleUrls: ['./building-image-details.component.scss']
})
export class BuildingImageDetailsComponent {
 defaultBuildingImage = 'assets/image/building_image.svg';

  imageList: string[] = [];
  validImages: string[] = [];

  buildingId!: number;
  isLoading: boolean = false;

  currentIndex: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<BuildingImagesDetialsComponent>,
    private hygieneService: BuildingDataService
  ) {}

  ngOnInit(): void {
    this.buildingId = this.data.buildingId;
    this.loadImageList();
  }

  loadImageList(): void {
    this.isLoading = true;

    // this.hygieneService.getBuildingImageList(this.buildingId).subscribe({
    //   next: (res: any) => {
    //     this.imageList = res?.buildingImageUrlList || [];
    //     this.validateImages();
    //   },
    //   error: () => {
    //     this.validImages = [];
    //     this.isLoading = false;
    //   }
    // });
  }

  validateImages() {
    const valid: string[] = [];
    let loaded = 0;

    if (this.imageList.length === 0) {
      this.isLoading = false;
      return;
    }

    this.imageList.forEach(url => {
      const img = new Image();

      img.onload = () => {
        valid.push(url);
        loaded++;
        this.finishValidation(valid, loaded);
      };

      img.onerror = () => {
        loaded++;
        this.finishValidation(valid, loaded);
      };

      img.src = url;
    });
  }

  finishValidation(valid: string[], loaded: number) {
    if (loaded === this.imageList.length) {
      this.validImages = valid;
      this.currentIndex = 0;
      this.isLoading = false;
    }
  }

  next() {
    if (this.currentIndex < this.validImages.length - 1) {
      this.currentIndex++;
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
